import React from "react";

export const DateCardLoading = () => {
  return (
    <div className="animate-pulse bg-gray-200 rounded-xl px-2 py-3 flex justify-between items-center">
      <div className="px-6 py-6 bg-yellow-200 rounded-xl text-sm"></div>
      <div className="text-center">
        <p className="text-xs font-medium">Total Transaction</p>
        <span className="text-lg"></span>
      </div>
    </div>
  );
};

export const ItemCardLoading = () => {
  return (
    <div className="animate-pulse rounded-xl px-2 py-8 text-center bg-gray-200"></div>
  );
};
